
import Combobox from "@ls/react-combobox-grid";
import PropTypes from "prop-types";
import React, { memo, useMemo } from "react";
import { Cell, Grid } from "styled-css-grid";
import {useSelector} from 'react-redux';
import {selectAllHoldingAttributes, selectFetchingHoldingAttibutes} from 'state/selections/selectors';

const HoldingAttributeComplication = ({ setDefinition, definition }) => {

 const attributes = useSelector(selectAllHoldingAttributes);
 const fetchingAttributes = useSelector(selectFetchingHoldingAttibutes);
  const [setAttribute] = useMemo(() => {
    return [(value) => setDefinition(definition.setAttribute(value))];
  }, [definition, setDefinition]);

  return (
    <Grid columns={1} gap="4px">
      <Cell>
        <Combobox
          options={attributes}
          onChange={setAttribute}
          isLoading={fetchingAttributes}
          value={definition.attribute}
          label="Attribute:"
          clearable
          variation={0}
          size={"S"}
          gridHeight={175}
        />
      </Cell>
    </Grid>
  );
};

HoldingAttributeComplication.propTypes = {
  setDefinition: PropTypes.func.isRequired,
  definition: PropTypes.object.isRequired,
};

export default memo(HoldingAttributeComplication);
